/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Link, Typography2 } from '@coursera/cds-core';

import { getPartnerPageUrl } from 'bundles/graphql/utils/Partners';
import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';
import type { PartnerListingPagePartnerFragment as PartnerListingPagePartner } from 'bundles/partners-graphql/queries/__generated__/GetAllPartners';

const IMAGE_SIZE = 150;

const styles = {
  partnerBox: css`
    width: 20%;
    margin: 10px 0;

    /* Bugfix for IE. James tried to use display, height, position fields
    but unfortunately none of them work very well */
    min-height: 260px;

    a {
      width: 90%;
      margin: 0 5%;
    }

    .partner-box-wrapper {
      transition: all 0.3s;
      text-align: center;
      padding: 15px;
      height: 100%;
    }

    img {
      width: 100%;
      height: auto;
    }

    p {
      margin: 10px;
      color: #0062e4;
    }

    @media (max-width: 1023px) {
      width: 25%;
    }

    @media (max-width: 767px) {
      width: 33.33%;
    }

    @media (max-width: 480px) {
      width: 50%;
    }
  `,
};

type Props = {
  partner: PartnerListingPagePartner;
};

const PartnerBox = ({ partner }: Props) => {
  const isExternal = partner.homePageOverride;
  const externalTarget = isExternal ? '_blank' : undefined;
  const externalRel = isExternal ? 'noopener noreferrer' : undefined;

  return (
    <div css={styles.partnerBox} className="rc-PartnerBox vertical-box">
      <Link
        component={TrackedLink2}
        variant="standard"
        href={{ pathname: getPartnerPageUrl(partner) }}
        trackingName="partner_link"
        className="partner-box vertical-box flex-1"
        target={externalTarget}
        rel={externalRel}
      >
        <div className="partner-box-wrapper card-one-clicker flex-1">
          <Imgix
            src={partner.squareLogo || ''}
            alt={`${partner.name} Logo`}
            maxWidth={IMAGE_SIZE}
            maxHeight={IMAGE_SIZE}
            imgParams={{ fit: 'crop' }}
          />
          <Typography2 component="p" variant="bodySecondary">
            {partner.name}
          </Typography2>
        </div>
      </Link>
    </div>
  );
};

export default PartnerBox;
